<template>
  <div 
    :class="getCardClass(color)"
    class="rounded-xl shadow-md p-4 hover:shadow-lg transition-all"
  >
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <p class="text-sm font-medium text-gray-600 mb-1">{{ title }}</p>
        <p class="text-2xl font-bold text-gray-900">{{ value }}</p>
      </div>
      <div class="text-4xl opacity-80">{{ icon }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiCard',
  props: {
    title: String,
    value: [String, Number],
    icon: String,
    color: String
  },
  methods: {
    getCardClass(color) {
      const colorClasses = {
        blue: 'bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200',
        purple: 'bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200',
        indigo: 'bg-gradient-to-br from-indigo-50 to-indigo-100 border border-indigo-200',
        green: 'bg-gradient-to-br from-green-50 to-green-100 border border-green-200',
        yellow: 'bg-gradient-to-br from-yellow-50 to-yellow-100 border border-yellow-200'
      };
      return colorClasses[color] || 'bg-gradient-to-br from-gray-50 to-gray-100';
    }
  }
};
</script>
